import React, { Fragment, useState } from 'react';
import { Checkbox, FormControlLabel, Typography, Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from '../../../../component/cards/MainCard';

const CheckboxInput = ({ questionnaireData }) => {
    return (
        <MainCard
            title={
                questionnaireData.questionNumber
                    ? `Questão ${questionnaireData.questionNumber}`
                    : null
            }
            sx={{ mb: 2 }}
        >
            <Box sx={{ p: 3 }}>
                <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
                    {questionnaireData.value}
                </Typography>
                {questionnaireData.options.map((option, i) => (
                    <FormControlLabel
                        key={i}
                        control={
                            <Checkbox
                                checked={
                                    Array.isArray(questionnaireData.answer) &&
                                    questionnaireData.answer.includes(option.value)
                                }
                                disabled
                            />
                        }
                        label={option.label}
                    />
                ))}
            </Box>
        </MainCard>
    );
};

CheckboxInput.propTypes = {
    questionnaireData: PropTypes.shape({
        id: PropTypes.any.isRequired,
        questionNumber: PropTypes.number,
        value: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired
            }).isRequired
        ).isRequired
    }).isRequired,
    onInputChange: PropTypes.func.isRequired
};

export default CheckboxInput;
